/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */
import { AppState } from "Dataflows/Reducers";
import { ISchoolDataState, ISchoolData, ISchoolOptionList } from "../../Interfaces/SiteContent";

/**
 * Schools data selector.
 */
export const getSchools = (state: ISchoolDataState): ISchoolData[] => state.schools;

/**
 * School option list data selector.
 */
export const getSchoolOptionList = (state: ISchoolDataState): ISchoolOptionList[] =>
  state.schoolOptionList;

export const getAppStateSchoolOptionList = (state: AppState): ISchoolOptionList[] =>
  state.schoolDataState.schoolOptionList;

/**
 * School data loadError selector.
 */
export const getSchoolloadError = (state: ISchoolDataState): string => state.schoolDataLoadError;

export const getAppStateSchoolLoadError = (state: AppState): string =>
  state.schoolDataState.schoolDataLoadError;
